// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
// import * as ActiveStorage from "@rails/activestorage"

Rails.start()
Turbolinks.start()
// ActiveStorage.start()

// require("chartkick").use(require("highcharts"))

import 'bootstrap'

import "src/controllers"
import "src/init"
import "src/app"

// require.context("../audio", true)

// import "images/logo.svg"